import script from "./GridAdvisorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridAdvisorComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridAdvisorComponent.vue?vue&type=style&index=0&id=bdaa6452&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdaa6452"]])

export default __exports__